import React from "react";
import { highlightMql4 } from "@/lib/mql4highlight";
import { toast } from "sonner";
import { Copy, Download } from "lucide-react";

export default function CodeViewer({ code, filename = "Strategy.mq4", onDownload }) {
  const highlighted = highlightMql4(code || "");
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code || "");
      toast.success("MQL4 code copied to clipboard");
    } catch {
      toast.error("Copy failed");
    }
  };
  const download = () => {
    if (onDownload) return onDownload();
    const blob = new Blob([code || ""], { type: "text/x-mql4" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
    toast.success("Downloaded " + filename);
  };
  return (
    <div className="flex flex-col h-full" data-testid="code-viewer">
      <div className="flex items-center justify-between px-3 py-2 border-b border-white/5 bg-[#0B0D12]">
        <div className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-full bg-[#FF3366]/70"></span>
          <span className="h-2.5 w-2.5 rounded-full bg-[#FFB800]/70"></span>
          <span className="h-2.5 w-2.5 rounded-full bg-[#00FF66]/70"></span>
          <span className="ml-3 text-[11px] font-mono text-[var(--text-secondary)]" data-testid="code-filename">
            {filename}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button data-testid="code-copy-btn" onClick={copy}
            className="text-xs font-mono flex items-center gap-1.5 px-2 py-1 border border-white/10 rounded hover:border-[var(--accent)] hover:text-[var(--accent)] transition-colors">
            <Copy size={12} /> COPY
          </button>
          <button data-testid="code-download-btn" onClick={download}
            className="text-xs font-mono flex items-center gap-1.5 px-2 py-1 bg-[var(--accent)] text-[#05070A] rounded hover:bg-white transition-colors">
            <Download size={12} /> .MQ4
          </button>
        </div>
      </div>
      <div className="code-block flex-1 min-h-[300px]">
        <pre>
          {highlighted.map((tokens, idx) => (
            <div className="code-line" key={idx}>
              <span className="code-lineno">{idx + 1}</span>
              <span className="code-content">
                {tokens.map((t, k) => (
                  <span key={k} className={`tok-${t.type}`}>{t.text}</span>
                ))}
                {"\n"}
              </span>
            </div>
          ))}
        </pre>
      </div>
    </div>
  );
}
